import { useState } from "react";
import dynamic from "next/dynamic";

import { type StartAgreementDrawerConfig, StartAgreementDrawerContext } from "~/contexts/StartAgreementDrawerContext";

const StartAgreementDrawer = dynamic(() =>
  // biome-ignore lint/plugin/no-async-import: defer StartAgreementDrawer (google-libphonenumber, @remi/formatting) from _app chunk
  import(
    "~/components/tasks/task-type-components/record-upsell-results/upsell-results-components/StartAgreementDrawer"
  ).then((m) => m.StartAgreementDrawer),
);

export const StartAgreementDrawerProvider = ({ children }: { children: React.ReactNode }) => {
  const [config, setConfig] = useState<StartAgreementDrawerConfig | null>(null);

  return (
    <StartAgreementDrawerContext.Provider value={{ openStartAgreement: setConfig }}>
      {children}
      {config && (
        <StartAgreementDrawer
          open
          onClose={() => setConfig(null)}
          readOnly={config.readOnly}
          bid={config.bid}
          homeowner={config.homeowner}
          quoteVersionOverrideId={config.quoteVersionOverrideId}
          requestForQuoteId={config.requestForQuoteId}
          taskId={config.taskId}
          isHrmAssigned={config.isHrmAssigned}
          isTaskCompleted={config.isTaskCompleted}
        />
      )}
    </StartAgreementDrawerContext.Provider>
  );
};
